<script setup lang="ts">
import SingleCard from '@/components/taro/SingleCard.vue'


</script>

<template>
    <div class="card_list">
        <transition-group name="list-complete">
            <SingleCard v-for="card, index in cards" :key="card.path" :index="index" :path="card.path" :class="'card '+card.classes"></SingleCard>

        </transition-group>
    </div>
</template>



<script lang="ts">
import { defineComponent } from 'vue'
interface Card {
    path: string
    classes: string
}
export default defineComponent({
    props: {
        cards: Array as () => Card[]
    },
    methods: {
        
    },

    name: 'CardList',

})
</script>

<style scoped>
.card_list {
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 1;
    padding: 30px;
    justify-content: space-around;
    row-gap: 10px;
}
.list-complete-move {
    transition: all 1s;
}
</style>